import { useState } from 'react';
import styled from 'styled-components';
import { Input } from './input';
import { CrossIcon, SearchIcon } from '../icons';
import { addAlpha } from '@algoan/deep-dive/theme';

export interface SearchInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onCrossClick: () => void;
  placeholder: string;
  className?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  id,
  value,
  onChange,
  onCrossClick,
  placeholder,
  className,
}) => {
  const [inputSelected, setInputSelected] = useState(false);
  const hasValueOrSelected = inputSelected || !!value;

  return (
    <Container className={className} onBlur={() => setInputSelected(false)} onFocus={() => setInputSelected(true)}>
      <S.Input
        data-testid="classic-search-input"
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        // disable Dashlane autofill
        data-form-type="other"
      />
      <S.IconContainer>
        {hasValueOrSelected ? (
          <S.CrossIconContainer onClick={onCrossClick} role="button" data-testid="clear-search">
            <CrossIcon size="large" />
          </S.CrossIconContainer>
        ) : (
          <S.SearchIconContainer>
            <SearchIcon />
          </S.SearchIconContainer>
        )}
      </S.IconContainer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 400px;
  height: 40px;
`;

const S = {
  Input: styled(Input)`
    width: 100%;
    height: 100%;
    color: ${(props) => props.theme.algoanBlue};

    input {
      padding: 0px 46px 0px 15px;
      font-size: 14px;
      height: 100%;
      &::placeholder {
        line-height: 18px;
        color: ${(props) => props.theme.secondary.softBlue1};
      }

      border: 1px solid ${(props) => addAlpha(props.theme.secondary.softBlue1, 0.5)};
      border-radius: 6px;
    }
  `,
  IconContainer: styled.div`
    position: absolute;
    box-sizing: border-box;
    width: 46px;
    height: 100%;
    top: 0px;
    right: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  SearchIconContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    opacity: 0.5;
    ${Container}:hover &, ${Container}:focus-within & {
      opacity: 1;
    }
  `,
  CrossIconContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  `,
};
